import { render } from "./intOptionsValue.vue?vue&type=template&id=08682c45&ts=true"
import script from "./intOptionsValue.vue?vue&type=script&lang=ts"
export * from "./intOptionsValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__